import DataProviderListDto from "./DataProviderListDto";

export default class DataSourceSelectionDto {

    constructor(dataProvider: DataProviderListDto | null) {
        this.DataProvider = dataProvider;
    }

    DataProvider: DataProviderListDto | null;
}